import { render, staticRenderFns } from "./walletAddress.vue?vue&type=template&id=41624b8a&scoped=true"
import script from "./walletAddress.vue?vue&type=script&lang=ts"
export * from "./walletAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41624b8a",
  null
  
)

export default component.exports